import React from 'react';
import { motion } from 'framer-motion';
const levels = [{
  title: 'Cycle 4',
  description: 'Matière, mélanges, transformations chimiques, atomes, ions et premières représentations pour construire et consolider les notions fondamentales.'
}, {
  title: 'Lycée',
  description: 'Structure atomique, liaisons, quantité de matière, transformations chimiques, stœchiométrie, acide-base, titrages, cinétique et chimie organique selon les besoins de la classe.'
}, {
  title: 'Révision & approfondissement',
  description: 'Des ressources utilisables pour réactiver, consolider ou approfondir une notion selon le niveau des élèves et votre progression.'
}];
export function TargetLevelsSection() {
  return <section className="w-full bg-white px-5 py-8 sm:py-12" data-id="element-195" data-mp="24yhaofti309e">
      <div className="mx-auto max-w-5xl" data-id="element-196" data-mp="3bfkylb38nlnc">
        <div className="mx-auto max-w-2xl text-center" data-id="element-197" data-mp="3bj0c49h9kmmn">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-198" data-mp="3gefoewzmiagy">
            Pour quels niveaux ?
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-ink/75 sm:mt-4 sm:text-base" data-id="element-199" data-mp="2g2uicxnad973">
            CHIMIE VISUELLE™ rassemble des ressources de chimie pour le secondaire, organisées par
            notion afin que chaque enseignant puisse sélectionner les supports adaptés à son niveau, à
            sa progression et aux besoins de sa classe.
          </p>
        </div>

        <div className="mt-6 grid gap-4 sm:mt-10 sm:gap-6 md:grid-cols-3" data-id="element-200" data-mp="1x7mbu4u6yn02">
          {levels.map((level, i) => <motion.article key={level.title} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-cobalt/20 bg-cobalt/5 p-5 shadow-sm sm:p-6" data-id="element-201" data-mp="1sdrtb4qboe2k" data-mpi={i}>
              <h3 className="text-lg font-bold text-cobalt-deep sm:text-xl" data-id="element-202" data-mp="ztebo2te17ut">{level.title}</h3>
              <p className="mt-2 text-[13px] leading-relaxed text-ink/80 sm:text-sm" data-id="element-203" data-mp="14s7qbykev4wk">
                {level.description}
              </p>
            </motion.article>)}
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center text-[13px] font-medium text-ink/70 sm:mt-8 sm:text-sm" data-id="element-204" data-mp="uu1pzle966tt">
          Vous choisissez les ressources adaptées à vos classes : la bibliothèque n’impose aucune
          progression unique.
        </p>
      </div>
    </section>;
}